import type { ReactNode } from 'react'
import { Wordmark } from './wordmark'
import styles from './auth-layout.module.scss'

type Props = { children: ReactNode }

/**
 * Centered narrow column for /sign-in and /not-authorized. No nav, no
 * data fetching — these pages exist outside the authed AppShell.
 */
export function AuthLayout({ children }: Props) {
  return (
    <div className={styles.outer}>
      <div className={styles.inner}>
        <header className={styles.header}>
          <Wordmark />
        </header>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  )
}
